import { useSort } from '../Table/hooks/useSort/index.js';
import { HeaderTextContainer, HeaderText, StyledButton } from './styled.js';
import { SortIcon } from './SortIcon.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function TableHeaderText(props) {
  var children = props.children,
    sortId = props.sortId;
  var _useSort = useSort(sortId),
    order = _useSort.order,
    onSort = _useSort.onSort;
  if (!sortId) {
    return /*#__PURE__*/jsx(HeaderTextContainer, {
      children: /*#__PURE__*/jsx(HeaderText, {
        children: children
      })
    });
  }
  return /*#__PURE__*/jsx(StyledButton, {
    type: "button",
    appearance: "ghost",
    onClick: onSort,
    children: /*#__PURE__*/jsxs(HeaderTextContainer, {
      children: [/*#__PURE__*/jsx(HeaderText, {
        children: children
      }), /*#__PURE__*/jsx(SortIcon, {
        order: order
      })]
    })
  });
}

export { TableHeaderText };
